import { TPanelZoneCoordinates } from '../types';

export const isCursorInArea = ({
  top,
  bottom,
  left,
  right,
  cursorX,
  cursorY,
}: TPanelZoneCoordinates) => {
  return (
    top <= cursorY && cursorY <= bottom && left <= cursorX && cursorX <= right
  );
};
